import { Formik } from 'formik'
import React, { useState } from 'react'
import { useSaveUserData } from 'src/Libs/user/hooks/use-save-user-data'
import { AccountProfileForm } from 'src/Libs/user/types'
import { UserData } from 'src/State/User/UserModel'
import UserProfileForm from './UserProfileForm'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ContactData } from 'src/Libs/user/models'
import useModals from 'src/Hooks/useModals'
import { useUserProfileSettingsFormInitializer } from 'src/Libs/user/hooks'

interface Props {
  title: string
  user: UserData
  userContact?: ContactData
  onSubmitUserData?: () => void
}

const UserProfileData: React.VFC<Props> = ({ title, user, userContact, onSubmitUserData }) => {
  const { t } = useCustomTranslation()
  const { saveUserData } = useSaveUserData()
  const { openConfirmationModal } = useModals()
  const { initialValues, validationSchema } = useUserProfileSettingsFormInitializer(user, userContact)
  const [formValues, setFormValues] = useState<AccountProfileForm>(initialValues)

  const onSave = (values: AccountProfileForm, onClose?: () => void): void => {
    const afterSubmit = (): void => {
      onSubmitUserData?.()
      onClose?.()
    }

    saveUserData(values, formValues, setFormValues, afterSubmit)
  }

  const onSubmit = (values: AccountProfileForm): void => {
    const isEmailUsernameEqual = formValues.username === formValues.eMail

    if (values.eMail !== formValues.eMail) {
      openConfirmationModal({
        title: t('user.user-profile.change-email-dialog.title'),
        text: isEmailUsernameEqual ? t('user.user-profile.change-email-username-dialog.text') : t('user.user-profile.change-email-dialog.text'),
        onConfirm: onClose => onSave(values, onClose),
        buttonText: [t('common.cancel'), t('common.confirm')],
      })
    } else {
      onSave(values)
    }
  }

  return (
    <Formik initialValues={formValues} onSubmit={onSubmit} enableReinitialize validationSchema={validationSchema}>
      <UserProfileForm title={title} />
    </Formik>
  )
}

export default UserProfileData
